import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToSciNotation',
})
export class NumberToSciNotationPipe implements PipeTransform {
  transform(value: number, maxLength = 8, fractionDigits = 3): string | number {
    if (!value) {
      return value;
    }

    const shortNumber = String(Math.abs(value)).length <= maxLength;
    if (shortNumber) {
      return value;
    }

    return value.toExponential(fractionDigits);
  }
}
